var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17582 11.27C1.35884 11.2695 1.54414 11.1982 1.68461 11.0577L6.2892 6.4531C6.54542 6.19688 6.50104 5.75719 6.23796 5.4941L1.68455 0.940694C1.40363 0.65977 0.951577 0.65977 0.670654 0.940694C0.392015 1.22162 0.390644 1.67093 0.670654 1.95094L4.71888 5.99916L0.670654 10.0474C0.38973 10.3283 0.38973 10.7804 0.670654 11.0613C0.811115 11.2017 0.992806 11.2705 1.17582 11.27Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.79ab35af28c1bfba54767e9532ed9c68.svg";
export { ForwardRef as ReactComponent };